import { render, staticRenderFns } from "./text-truncate.vue?vue&type=template&id=25f8a52c&"
import script from "./text-truncate.vue?vue&type=script&lang=js&"
export * from "./text-truncate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports